module.exports = __webpack_public_path__ + "img/moyudanLogo.4ad5bf50.png";